const setupStripeCardTokenHandler = () => {
  const stripeDOMElement = document.getElementById('stripe_publishable_key');
  if (!stripeDOMElement) return;

  const stripePublishableKey = stripeDOMElement.value;
  const stripe = Stripe(stripePublishableKey);
  const style = {
    base: {
      fontSize: '16px',
      color: '#32325d',
    },
  };

  const card = stripe.elements().create('card', { style });
  card.mount('#card-element');

  // Create a token or display an error when the form is submitted.
  const form = document.getElementById('new_employee');
  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const { token, error } = await stripe.createToken(card);

    if (error) {
      const errorElement = document.getElementById('card-errors');
      errorElement.textContent = error.message;
    } else {
      stripeTokenHandler(token);
    }
  });
}

const stripeTokenHandler = (token) => {
  const form = document.getElementById('new_employee');

  const tokenInput = document.createElement('input');
  tokenInput.setAttribute('type', 'hidden');
  tokenInput.setAttribute('name', 'stripe_token');
  tokenInput.setAttribute('value', token.id);
  form.appendChild(tokenInput);

  form.submit();
}

const tieredPricingData = (tiers) => {
  return {
    seats_count: 20,
    billing_scheme: 'tiered',
    tiers: tiers,
    
    calculateTieredPrice(usage) {
      let counted = 0;
      let dollarTotal = 0;
      
      for (let tier of this.tiers) {
        let upTo = tier.up_to || Infinity;
        let tierUsage = 0;
        
        // Count how many seats fall into this tier
        while (counted < upTo && usage > 0) {
          counted += 1;
          tierUsage += 1;
          usage -= 1;
        }
        
        // If any seats fall into this tier, add the costs
        if (tierUsage > 0) {
          // Add flat amount once per tier (if it exists)
          if (tier.flat_amount && tier.flat_amount > 0) {
            dollarTotal += tier.flat_amount / 100.0;
          }
          
          // Add unit amount for each seat in this tier
          dollarTotal += (tierUsage * tier.unit_amount) / 100.0;
        }
        
        if (usage === 0) break;
      }
      
      return dollarTotal;
    },
    
    get totalPrice() {
      return this.calculateTieredPrice(this.seats_count);
    }
  };
};

// Make tieredPricingData available globally for Alpine.js
window.tieredPricingData = tieredPricingData;

export { setupStripeCardTokenHandler, stripeTokenHandler, tieredPricingData }

document.addEventListener('turbolinks:load', () => {
  setupStripeCardTokenHandler();
});
